var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-2"},_vm._l((_vm.logicJump.actions),function(action){return _c('logic-jump-action',{key:action.id,attrs:{"form":_vm.form,"logicJump":_vm.logicJump,"action":action}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }